import React from "react";
import { useStyletron } from "@mezo-org/mezo-clay";
import ListingItem from "../ListingItem";
export default function AccountBalance(props) {
    const { totalBalance, totalDebt } = props;
    const [, theme] = useStyletron();
    return (React.createElement(ListingItem, { label: "Total assets", value: totalBalance, subLabel: "Total liabilities", subValue: totalDebt, overrides: {
            Root: {
                style: {
                    borderBottom: `1px solid ${theme.colors.borderInverseSelected}`,
                },
            },
        } }));
}
//# sourceMappingURL=AccountBalance.js.map